const eukanubaProducts = [
  {
    image: '/pet_images/EU_Mini_Puppy.jpg',
    id: 'EU_Mini_Puppy_3kg',
    name: 'Eukanuba Small Puppy (3kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3,
    price: 459,
    category: 'Dry food',
    brand: 'Eukanuba',
    age: 'Puppy',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Eukanuba Small Puppy Food is suitable for puppies aged 2-10 months that will have an adult weight of up to 10kg.Contains a special combination of proteins, vitamins, minerals, and a patented complex of antioxidants - all designed to keep your...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>The Eukanuba Small Puppy Food</strong> is suitable for puppies aged 2-10 months that will have an adult weight of up to 10kg.</p><p><span>Contains a special combination of proteins, vitamins, minerals, and a patented complex of antioxidants - all designed to keep your puppy healthy as it grows into a strong adult dog.</span></p><p><strong>Key Features:</strong></p><ul><li><strong>Immune system support:</strong> Helps support your puppy’s natural defences thanks to a complex of antioxidants including vitamin E.</li><li><strong>Digestive health:</strong> Combination of nutrients with high quality protein and prebiotics to support digestive health and balance of intestinal flora, which contributes to good stool quality. </li><li><strong>Intense energy content:</strong> Meets the energy needs of small breed puppies during the growth period, and satisfies fussy appetites.</li><li><strong>Growth &amp; weight control: </strong><span>Contains a moderate level of fat to help limit weight gain with no compromise on the intake of protein, calcium, and phosphorus for a healthy growth.</span></li></ul></div>',
    keyBenefits: [
      'Immune system support:',
      'Digestive health:',
      'Intense energy content:',
      'Growth & weight control:',
    ],
    feedingGuide: [
      {
        weight: 'AGE (MONTHS)',
        idealWeight: 'ADULT WEIGHT = 2 KG',
        overweight: 'ADULT WEIGHT = 6 KG',
      },
      {
        weight: '2 m',
        idealWeight: '49 g (4/8 cups)',
        overweight: '103 g (1+1/8 cups)',
      },
      {
        weight: '3 m',
        idealWeight: '54 g (5/8 cups)',
        overweight: '119 g (1+2/8 cups)',
      },
      {
        weight: '4 m',
        idealWeight: '55 g (5/8 cups)',
        overweight: '125 g (1+3/8 cups)',
      },
      {
        weight: '5 m',
        idealWeight: '55 g (5/8 cups)',
        overweight: '126 g (1+3/8 cups)',
      },
      {
        weight: '6 m',
        idealWeight: '48 g (4/8 cups)',
        overweight: '125 g (1+3/8 cups)',
      },
      {
        weight: '7 m',
        idealWeight: '40 g (4/8 cups)',
        overweight: '113 g (1+2/8 cups)',
      },
      {
        weight: '8 m',
        idealWeight: '39 g (3/8 cups)',
        overweight: '101 g (1+1/8 cups)',
      },
      {
        weight: '9 m',
        idealWeight: '39 g (3/8 cups)',
        overweight: '90 g (1 cups)',
      },
      {
        weight: '10 m',
        idealWeight: '39 g (3/8 cups)',
        overweight: '89 g (1 cups)',
      },
      {
        weight: '11 m',
        idealWeight: 'Transition to Small Adult',
        overweight: 'Transition to Small Adult',
      },
    ],
    additionalInfo: {
      brands: 'Eukanuba',
      pet_type: 'No',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Immune Support',
      breed: 'No',
      breed_size: 'Small Breed',
      flavour: 'Chicken',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/EU_Mini_Adult.jpg',
    id: 'EU_Mini_Adult_3kg',
    name: 'Eukanuba Small Adult (3kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3,
    price: 431,
    category: 'Dry food',
    brand: 'Eukanuba',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Eukanuba Small Adult Dog Food is designed for adult small breed dogs (weight between 1 and 10 kg) - Over 10 months old. Eukanuba Small Adult is formulated with nutrients that help to meet those energy needs, whilst also helping your dog to...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Eukanuba Small Adult Dog Food</strong> is designed f<span>or adult small breed dogs (weight between 1 and 10 kg) - Over 10 months old.</span></p><p><span></span><span>Eukanuba Small Adult is formulated with nutrients that help to meet those energy needs, whilst also helping your dog to maintain a healthy weight.</span></p><p><strong>Key Benefits:</strong></p><ul><li><strong>Adapted energy :</strong> Helps maintain a healthy weight in small breed dogs by perfectly meeting their high energy needs.</li><li><strong>Enhanced palatability :</strong> Satisfies the fussy appetite of small breed dogs by means of its formulation and a selection of exclusive flavourings.</li><li><strong>Coat condition :</strong> This formula contains nutrients that help support a healthy skin.</li></ul></div>',
    keyBenefits: [
      'Adapted energy :',
      'Enhanced palatability :',
      'Coat condition :',
    ],
    feedingGuide: [
      {
        weight: 'WEIGHT OF DOG',
        idealWeight: 'LOW ACTIVITY',
        overweight: 'MEDIUM ACTIVITY',
      },
      {
        weight: '2',
        idealWeight: '40 g (4/8 cup)',
        overweight: '47 g (4/8 cup)',
      },
      {
        weight: '3 kg',
        idealWeight: '55 g (5/8 cup)',
        overweight: '63 g (6/8 cup)',
      },
      {
        weight: '4 kg',
        idealWeight: '68 g (6/8 cup)',
        overweight: '79 g (7/8 cup)',
      },
      {
        weight: '5 kg',
        idealWeight: '80 g (7/8 cup)',
        overweight: '93 g (1 cup)',
      },
      {
        weight: '6 kg',
        idealWeight: '92 g (1 cup)',
        overweight: '106 g (1+1/8 cup)',
      },
      {
        weight: '7 kg',
        idealWeight: '103 g (1+1/8 cup)',
        overweight: '119 g (1+3/8 cup)',
      },
      {
        weight: '8 kg',
        idealWeight: '114 g (1+2/8 cup)',
        overweight: '132 g (1+4/8 cup)',
      },
      {
        weight: '9 kg',
        idealWeight: '125 g (1+3/8 cup)',
        overweight: '144 g (1+5/8 cup)',
      },
      {
        weight: '10 kg',
        idealWeight: '135 g (1+4/8 cup)',
        overweight: '156 g (1+6/8 cup)',
      },
    ],
    additionalInfo: {
      brands: 'Eukanuba',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'Small Breed',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/EU_Mini_Senior.jpg',
    id: 'EU_Mini_Senior_3kg',
    name: 'Eukanuba Small Senior (3kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3,
    price: 305,
    category: 'Dry food',
    brand: 'Eukanuba',
    age: 'Senior',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Eukanuba Small Ageing 12+ Adult Dog Food is designed for senior small breed dogs (up to 10 kg) - Over 12 years old.Eukanuba Small Ageing 12+ is also developed with an adapted phosphorus content, this helps to support and maintain healthy...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Eukanuba Small Ageing 12+ Adult Dog Food</strong> is designed f<span>or senior small breed dogs (up to 10 kg) - Over 12 years old.</span></p><p><span>Eukanuba Small Ageing 12+ is also developed with an adapted phosphorus content, this helps to support and maintain healthy kidney function in your dog as it ages.</span></p><p><strong>Key Features:</strong></p><ul><li><strong>Healthy ageing support : </strong><span>Developed to support healthy ageing in small breed dogs. </span></li><li><span><span><strong>Rehydratable senior kibble :</strong> easy to chew and is tailored for older dogs’ small teeth and jaws</span></span></li></ul></div>',
    keyBenefits: [
      'Healthy ageing support :',
      'Rehydratable senior kibble :',
    ],
    feedingGuide: [
      {
        weight: 'WEIGHT OF DOG',
        idealWeight: 'LOW ACTIVITY',
        overweight: 'MEDIUM ACTIVITY',
      },
      {
        weight: '2 kg',
        idealWeight: '40g (4/8 cup)',
        overweight: '47 g (4/8 cup)',
      },
      {
        weight: '3 kg',
        idealWeight: '54 g (5/8cup)',
        overweight: '63 g (6/8 cup)',
      },
      {
        weight: '4 kg',
        idealWeight: '68 g (6/8 cup)',
        overweight: '78 g (7/8 cup)',
      },
      {
        weight: '5 kg',
        idealWeight: '80 g (7/8 cup)',
        overweight: '93 g (1 cup)',
      },
      {
        weight: '6 kg',
        idealWeight: '92 g (1 cup)',
        overweight: '106 g (1+1/8 cups)',
      },
      {
        weight: '7 kg',
        idealWeight: '103 g (1+1/8 cups)',
        overweight: '119 g (1+2/8 cups)',
      },
      {
        weight: '8 kg',
        idealWeight: '114 g (1+2/8 cups)',
        overweight: '132 g (1+4/8 cups)',
      },
      {
        weight: '9 kg',
        idealWeight: '124 g (1+3/8 cups)',
        overweight: '144 g (1+5/8 cups)',
      },
      {
        weight: '10 kg',
        idealWeight: '134 g (1+4/8 cups)',
        overweight: '156 g (1+6/8 cups)',
      },
    ],
    additionalInfo: {
      brands: 'Eukanuba',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'No',
      breed: 'No',
      breed_size: 'Small Breed',
      flavour: 'Chicken',
      lifestage: 'Senior',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/EU_Medium_Puppy.jpg',
    id: 'EU_Medium_Puppy_4kg',
    name: 'Eukanuba Medium Puppy (4kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 4,
    price: 590,
    category: 'Dry food',
    brand: 'Eukanuba',
    age: 'Puppy',
    breed: '',
    needs: 'General',
    size: 'medium',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Eukanuba Medium Junior Puppy Food for medium breed puppies (adult weight from 11 to 25 kg) - up to 12 months old.Contains an increased protein content to help support healthy, muscular, and skeletal growth during the relatively short growth...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Eukanuba Medium Junior Puppy Food</strong> f<span>or medium breed puppies (adult weight from 11 to 25 kg) - up to 12 months old.</span></p><p><span>Contains an increased protein content to help support healthy, muscular, and skeletal growth during the relatively short growth period. Antioxidants are included to support your puppy\\\\\\\'s natural defences which can be a particular challenge during this life stage.</span></p><p><strong>Key Features:</strong><span></span></p><ul><li><strong>Immune system support :</strong> Helps support your puppy’s natural defences thanks particularly to a patented complex of antioxidants including vitamin E.</li><li><strong>Digestive health :</strong> Combination of nutrients with high quality protein and prebiotics to support digestive health and balance of intestinal flora, which contributes to good stool quality. </li><li><strong>Short growth - high energy content :</strong> Meets the high energy needs of medium breed puppies which have a short growth period.</li></ul></div>',
    keyBenefits: [
      'Immune system support :',
      'Digestive health :',
      'Short growth - high energy content :',
    ],
    feedingGuide: [
      {
        weight: 'AGE (MONTHS)',
        idealWeight: 'ADULT WEIGHT = 11 KG',
        overweight: 'ADULT WEIGHT = 14 KG',
      },
      {
        weight: '2 m',
        idealWeight: '155 g (1+4/8 cups)',
        overweight: '184 g (1+7/8 cups)',
      },
      {
        weight: '3 m',
        idealWeight: '182 g (1+6/8 cups)',
        overweight: '216 g (2+1/8 cups)',
      },
      {
        weight: '4 m',
        idealWeight: '194 g (1+7/8 cups)',
        overweight: '232 g (2+2/8 cups)',
      },
      {
        weight: '5 m',
        idealWeight: '197 g (2 cups)',
        overweight: '236 g (2+3/8 cups)',
      },
      {
        weight: '6 m',
        idealWeight: '197 g (2 cups)',
        overweight: '236 g (2+3/8 cups)',
      },
      {
        weight: '8 m',
        idealWeight: '159g (1+5/8 cups)',
        overweight: '204 g (2 cups)',
      },
      {
        weight: '10 m',
        idealWeight: '141 g (1+3/8 cups)',
        overweight: '169 g (1 +5/8 cups)',
      },
      {
        weight: '12 m',
        idealWeight: 'Transition to Medium Adult',
        overweight: 'Transition to Medium Adult',
      },
      {
        weight: '13 m',
        idealWeight: 'Medium Adult',
        overweight: 'Medium Adult',
      },
    ],
    additionalInfo: {
      brands: 'Eukanuba',
      pet_type: 'No',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'No',
      breed: 'No',
      breed_size: 'Medium Breed',
      flavour: 'Chicken',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/EU_Medium_Adult.jpg',
    id: 'EU_Medium_Adult_4kg',
    name: 'Eukanuba Medium Adult (4kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 4,
    price: 593,
    category: 'Dry food',
    brand: 'Eukanuba',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'medium',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Eukanuba Medium Adult Dog Food is designed for adult medium breed dogs (from 11 to 25 kg) - From 12 months to 7 years old.Eukanuba Medium Adult contains an exclusive antioxidant complex, as well as nutrients like manno-oligo-saccharides,...',
    longDescription:
      '<div class="std" itemprop="description"><p>The<strong> Eukanuba Medium Adult Dog Food</strong> is designed for <span>adult medium breed dogs (from 11 to 25 kg) - From 12 months to 7 years old.</span></p><p><span>Eukanuba Medium Adult contains an exclusive antioxidant complex, as well as nutrients like manno-oligo-saccharides, to help support your dog’s natural defences, allowing it to maintain a healthy lifestyle. </span></p><p><strong>Key Benefits:</strong></p><ul><li><strong>Natural defences :</strong> Helps support your dog’s natural defences, thanks particularly to an antioxidant complex and manno-oligo-saccharides.</li><li><strong>High digestibility :</strong> Helps support optimal digestibility thanks to an exclusive formula including very high quality protein and a balanced supply of dietary fibre.</li><li><strong>Omega 3:</strong> Enriched with Omega 3 fatty acids (EPA-DHA) to help maintain healthy skin.</li></ul></div>',
    keyBenefits: [
      'Natural defences :',
      'High digestibility :',
      'Omega 3:',
    ],
    feedingGuide: [
      {
        weight: 'WEIGHT OF DOG',
        idealWeight: 'LOW ACTIVITY',
        overweight: 'MEDIUM ACTIVITY',
      },
      {
        weight: '11 kg',
        idealWeight: '149 g (1+4/8 cups)',
        overweight: '173 g (1+6/8 cups)',
      },
      {
        weight: '12 kg',
        idealWeight: '159 g (1+5/8 cups)',
        overweight: '185 g (1+7/8 cups)',
      },
      {
        weight: '14 kg',
        idealWeight: '179 g (1+7/8 cups)',
        overweight: '207 g (2+1/8 cups)',
      },
      {
        weight: '16 kg',
        idealWeight: '198 g (2+1/8 cups)',
        overweight: '229 g (2+3/8 cups)',
      },
      {
        weight: '18 kg',
        idealWeight: '216 g (2+2/8 cups)',
        overweight: '250 g (2+5/8 cups)',
      },
      {
        weight: '20 kg',
        idealWeight: '234 g (2+4/8 cups)',
        overweight: '271 g (2+7/8 cups)',
      },
      {
        weight: '22 kg',
        idealWeight: '251 g (2+5/8 cups)',
        overweight: '291 g (3 cups)',
      },
      {
        weight: '24 kg',
        idealWeight: '268 g (2+6/8 cups)',
        overweight: '310 g (3+2/8 cups)',
      },
      {
        weight: '25 kg',
        idealWeight: '276 g (2+7/8 cups)',
        overweight: '320 g (3+3/8 cups)',
      },
    ],
    additionalInfo: {
      brands: 'Eukanuba',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'No',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/EU_Medium_Senior.jpg',
    id: 'EU_Medium_Senior_4kg',
    name: 'Eukanuba Medium Senior (4kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 4,
    price: 641,
    category: 'Dry food',
    brand: 'Eukanuba',
    age: 'Senior',
    breed: '',
    needs: 'General',
    size: 'medium',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Eukanuba Medium Mature 7+ Adult Dog Food is designed for medium breed dogs (weight between 10 to 25 kg) over 7 years old.Eukanuba Medium Adult 7+ contains an exclusive complex of antioxidants to help neutralise free radicals and to help...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Eukanuba Medium Mature 7+ Adult Dog Food</strong> is designed for medium breed dogs (weight between 10 to 25 kg) over 7 years old.</p><p><span>Eukanuba Medium Adult 7+ contains an exclusive complex of antioxidants to help neutralise free radicals and to help maintain the condition of vital molecules in your dog\\\\\\\'s body</span></p><p><strong>Key Benefits: </strong></p><ul><li><strong>Vitality support :</strong> Adapted content of nutrients to help maintain vitality in medium breed dogs facing the first signs of ageing. Contains an exclusive complex of antioxidants to help neutralise free radicals.</li><li><strong>High digestibility :</strong> Helps support optimal digestibility thanks to an exclusive formula including very high quality protein and a balanced supply of dietary fibre.</li><li><strong>Coat condition :</strong> This formula contains nutrients that help support a healthy skin.</li></ul></div>',
    keyBenefits: [
      'Vitality support :',
      'High digestibility :',
      'Coat condition :',
    ],
    feedingGuide: [
      {
        weight: 'WEIGHT OF DOG',
        idealWeight: 'LOW ACTIVITY',
        overweight: 'MEDIUM ACTIVITY',
      },
      {
        weight: '11 kg',
        idealWeight: '149 g (1+4/8 cups)',
        overweight: '172 g (1+6/8 cups)',
      },
      {
        weight: '12 kg',
        idealWeight: '159 g (1+5/8 cups)',
        overweight: '184 g (1+7/8 cups)',
      },
      {
        weight: '14 kg',
        idealWeight: '178 g (1+7/8 cups)',
        overweight: '207 g (2+1/8 cups)',
      },
      {
        weight: '16 kg',
        idealWeight: '197 g (2 cups)',
        overweight: '228 g (2+3/8 cups)',
      },
      {
        weight: '18 kg',
        idealWeight: '215 g (2+2/8 cups)',
        overweight: '249 g (2+5/8 cups)',
      },
      {
        weight: '20 kg',
        idealWeight: '233 g (2+3/8 cups)',
        overweight: '270 g (2+7/8 cups)',
      },
      {
        weight: '22 kg',
        idealWeight: '250 g (2+5/8 cups)',
        overweight: '290 g (3 cups)',
      },
      {
        weight: '24 kg',
        idealWeight: '267 g (2+6/8 cups)',
        overweight: '309 g (3+2/8 cups)',
      },
      {
        weight: '25 kg',
        idealWeight: '276 g (2+7/8 cups)',
        overweight: '319 g (3+3/8 cups)',
      },
    ],
    additionalInfo: {
      brands: 'Eukanuba',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'No',
      breed: 'No',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'No',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/EU_Large_Puppy.jpg',
    id: 'EU_Large_Puppy_4kg',
    name: 'Eukanuba Large Puppy (3kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 4,
    price: 608,
    category: 'Dry food',
    brand: 'Eukanuba',
    age: 'Puppy',
    breed: '',
    needs: 'General',
    size: 'large',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Eukanuba Large Junior Puppy Food is designed for large breed puppies (adult weight between 25 to 45 kg) up to 15 months. Eukanuba Large Puppy food contains a patented complex of antioxidants - including the highly beneficial vitamin E to...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Eukanuba Large Junior Puppy Food </strong>is designed for large breed puppies (adult weight between 25 to 45 kg) up to 15 months. </p><p><span>Eukanuba Large Puppy food contains a patented complex of antioxidants - including the highly beneficial vitamin E to support your puppy\\\\\\\'s natural defences while its immune system is immature and still developing.</span></p><p><strong>Key Features:</strong><span></span></p><ul><li><strong>Immune system support : </strong>Helps support your puppy’s natural defences thanks particularly to a patented complex of antioxidants including vitamin E. </li><li><strong>Long growth - moderate energy :</strong> Meets the moderate energy needs of large breed puppies which have a long growth period.</li><li><strong>Digestive health :</strong> Combination of nutrients with high quality protein and prebiotics to support digestive health and balance of intestinal flora, which contributes to good stool quality.</li></ul></div>',
    keyBenefits: [
      'Immune system support :',
      'Long growth - moderate energy :',
      'Digestive health :',
    ],
    feedingGuide: [
      {
        weight: 'ADULT WEIGHT',
        idealWeight: '26KG',
        overweight: '-',
      },
      {
        weight: 'Age (month)',
        idealWeight: 'grams',
        overweight: 'cup',
      },
      {
        weight: '2m',
        idealWeight: '264g',
        overweight: '3+3/8',
      },
      {
        weight: '3m',
        idealWeight: '326g',
        overweight: '4+1/8',
      },
      {
        weight: '4m',
        idealWeight: '354g',
        overweight: '4+4/8',
      },
      {
        weight: '5m',
        idealWeight: '380g',
        overweight: '4+7/8',
      },
      {
        weight: '6m',
        idealWeight: '404g',
        overweight: '5+1/8',
      },
      {
        weight: '8m',
        idealWeight: '374g',
        overweight: '4+6/8',
      },
      {
        weight: '10m',
        idealWeight: '318g',
        overweight: '4+1/8',
      },
      {
        weight: '12m',
        idealWeight: '287g',
        overweight: '3+5/8',
      },
      {
        weight: '14m',
        idealWeight: '285g',
        overweight: '3+5/8',
      },
      {
        weight: '15m',
        idealWeight: '285g',
        overweight: '3+5/8',
      },
    ],
    additionalInfo: {
      brands: 'Eukanuba',
      pet_type: 'No',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'No',
      breed: 'No',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'No',
      size_chart: 'No',
    },
  },
  // -- New from 2026 Price List --
  {
    image: '/pet_images/EU_ActivAdvantage_Chicken_Rice_Small_Breed_Puppy_1kg.jpg',
    id: 'EU_ActivAdvantage_Chicken_Rice_Small_Breed_Puppy_1kg',
    name: 'Eukanuba ActivAdvantage Chicken & Rice Small Breed Puppy (1kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1,
    price: 92,
    category: 'Dry food',
    brand: 'Eukanuba',
    age: 'Puppy',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Complete feed for dogs - Suitable for small breed puppies (adult weight less than 11kg) from 1 to 12 months in age.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - Suitable for small breed puppies (adult weight less than 11kg) from 1 to 12 months in age.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Immune System Support - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Digestive Health - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Growth Support - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Immune System Support -',
      'Digestive Health -',
      'Growth Support -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Eukanuba',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/EU_ActivAdvantage_Chicken_Rice_Small_Breed_Puppy_3kg.jpg',
    id: 'EU_ActivAdvantage_Chicken_Rice_Small_Breed_Puppy_3kg',
    name: 'Eukanuba ActivAdvantage Chicken & Rice Small Breed Puppy (3kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3,
    price: 257,
    category: 'Dry food',
    brand: 'Eukanuba',
    age: 'Puppy',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Complete feed for dogs - Suitable for small breed puppies (adult weight less than 11kg) from 1 to 12 months in age.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - Suitable for small breed puppies (adult weight less than 11kg) from 1 to 12 months in age.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Immune System Support - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Digestive Health - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Growth Support - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Immune System Support -',
      'Digestive Health -',
      'Growth Support -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Eukanuba',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/EU_ActivAdvantage_Chicken_Rice_Small_Breed_Puppy_15kg.jpg',
    id: 'EU_ActivAdvantage_Chicken_Rice_Small_Breed_Puppy_15kg',
    name: 'Eukanuba ActivAdvantage Chicken & Rice Small Breed Puppy (15kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 15,
    price: 1154,
    category: 'Dry food',
    brand: 'Eukanuba',
    age: 'Puppy',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'Complete feed for dogs - Suitable for small breed puppies (adult weight less than 11kg) from 1 to 12 months in age.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - Suitable for small breed puppies (adult weight less than 11kg) from 1 to 12 months in age.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Immune System Support - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Digestive Health - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Growth Support - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Immune System Support -',
      'Digestive Health -',
      'Growth Support -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Eukanuba',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/EU_ActivAdvantage_Chicken_Rice_Small_Breed_Adult_1kg.jpg',
    id: 'EU_ActivAdvantage_Chicken_Rice_Small_Breed_Adult_1kg',
    name: 'Eukanuba ActivAdvantage Chicken & Rice Small Breed Adult (1kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1,
    price: 91,
    category: 'Dry food',
    brand: 'Eukanuba',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Complete feed for dogs - Suitable for small breed adults (less than 11kg) from 1 to 7 years in age.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - Suitable for small breed adults (less than 11kg) from 1 to 7 years in age.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Maintains Ideal Weight - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Healthy Skin & Coat - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Digestive Health - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Maintains Ideal Weight -',
      'Healthy Skin & Coat -',
      'Digestive Health -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Eukanuba',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/EU_ActivAdvantage_Chicken_Rice_Small_Breed_Adult_3kg.jpg',
    id: 'EU_ActivAdvantage_Chicken_Rice_Small_Breed_Adult_3kg',
    name: 'Eukanuba ActivAdvantage Chicken & Rice Small Breed Adult (3kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3,
    price: 242,
    category: 'Dry food',
    brand: 'Eukanuba',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Complete feed for dogs - Suitable for small breed adults (less than 11kg) from 1 to 7 years in age.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - Suitable for small breed adults (less than 11kg) from 1 to 7 years in age.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Maintains Ideal Weight - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Healthy Skin & Coat - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Digestive Health - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Maintains Ideal Weight -',
      'Healthy Skin & Coat -',
      'Digestive Health -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Eukanuba',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/EU_ActivAdvantage_Chicken_Rice_Small_Breed_Adult_9kg.jpg',
    id: 'EU_ActivAdvantage_Chicken_Rice_Small_Breed_Adult_9kg',
    name: 'Eukanuba ActivAdvantage Chicken & Rice Small Breed Adult (9kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 9,
    price: 669,
    category: 'Dry food',
    brand: 'Eukanuba',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '5.1-10kg',
    description:
      'Complete feed for dogs - Suitable for small breed adults (less than 11kg) from 1 to 7 years in age.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - Suitable for small breed adults (less than 11kg) from 1 to 7 years in age.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Maintains Ideal Weight - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Healthy Skin & Coat - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Digestive Health - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Maintains Ideal Weight -',
      'Healthy Skin & Coat -',
      'Digestive Health -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Eukanuba',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/EU_ActivAdvantage_Chicken_Rice_Small_Breed_Adult_15kg.jpg',
    id: 'EU_ActivAdvantage_Chicken_Rice_Small_Breed_Adult_15kg',
    name: 'Eukanuba ActivAdvantage Chicken & Rice Small Breed Adult (15kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 15,
    price: 1093,
    category: 'Dry food',
    brand: 'Eukanuba',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'Complete feed for dogs - Suitable for small breed adults (less than 11kg) from 1 to 7 years in age.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - Suitable for small breed adults (less than 11kg) from 1 to 7 years in age.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Maintains Ideal Weight - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Healthy Skin & Coat - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Digestive Health - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Maintains Ideal Weight -',
      'Healthy Skin & Coat -',
      'Digestive Health -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Eukanuba',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/EU_ActivAdvantage_Chicken_Rice_Small_Breed_Senior_3kg.jpg',
    id: 'EU_ActivAdvantage_Chicken_Rice_Small_Breed_Senior_3kg',
    name: 'Eukanuba ActivAdvantage Chicken & Rice Small Breed Senior (3kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3,
    price: 249,
    category: 'Dry food',
    brand: 'Eukanuba',
    age: 'Senior',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Complete feed for dogs - Suitable for small breed seniors (less than 11kg) over 7 years old.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - Suitable for small breed seniors (less than 11kg) over 7 years old.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Healthy Ageing - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Joint Support - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Skin & Coat Support - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Healthy Ageing -',
      'Joint Support -',
      'Skin & Coat Support -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Eukanuba',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Senior',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/EU_ActivAdvantage_Chicken_Rice_Medium_Breed_Puppy_3kg.jpg',
    id: 'EU_ActivAdvantage_Chicken_Rice_Medium_Breed_Puppy_3kg',
    name: 'Eukanuba ActivAdvantage Chicken & Rice Medium Breed Puppy (3kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3,
    price: 246,
    category: 'Dry food',
    brand: 'Eukanuba',
    age: 'Puppy',
    breed: '',
    needs: 'General',
    size: 'medium',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Complete feed for dogs - Suitable for medium breed puppies (adult weight 11kg to 24.5kg) from 1 to 12 months in age.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - Suitable for medium breed puppies (adult weight 11kg to 24.5kg) from 1 to 12 months in age.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Immune System Support - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Digestive Health - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Growth Support - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Immune System Support -',
      'Digestive Health -',
      'Growth Support -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Eukanuba',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/EU_ActivAdvantage_Chicken_Rice_Medium_Breed_Puppy_9kg.jpg',
    id: 'EU_ActivAdvantage_Chicken_Rice_Medium_Breed_Puppy_9kg',
    name: 'Eukanuba ActivAdvantage Chicken & Rice Medium Breed Puppy (9kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 9,
    price: 684,
    category: 'Dry food',
    brand: 'Eukanuba',
    age: 'Puppy',
    breed: '',
    needs: 'General',
    size: 'medium',
    sterilised: 'No',
    productSize: '5.1-10kg',
    description:
      'Complete feed for dogs - Suitable for medium breed puppies (adult weight 11kg to 24.5kg) from 1 to 12 months in age.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - Suitable for medium breed puppies (adult weight 11kg to 24.5kg) from 1 to 12 months in age.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Immune System Support - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Digestive Health - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Growth Support - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Immune System Support -',
      'Digestive Health -',
      'Growth Support -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Eukanuba',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/EU_ActivAdvantage_Chicken_Rice_Medium_Breed_Puppy_15kg.jpg',
    id: 'EU_ActivAdvantage_Chicken_Rice_Medium_Breed_Puppy_15kg',
    name: 'Eukanuba ActivAdvantage Chicken & Rice Medium Breed Puppy (15kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 15,
    price: 1078,
    category: 'Dry food',
    brand: 'Eukanuba',
    age: 'Puppy',
    breed: '',
    needs: 'General',
    size: 'medium',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'Complete feed for dogs - Suitable for medium breed puppies (adult weight 11kg to 24.5kg) from 1 to 12 months in age.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - Suitable for medium breed puppies (adult weight 11kg to 24.5kg) from 1 to 12 months in age.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Immune System Support - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Digestive Health - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Growth Support - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Immune System Support -',
      'Digestive Health -',
      'Growth Support -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Eukanuba',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/EU_ActivAdvantage_Chicken_Rice_Medium_Breed_Adult_3kg.jpg',
    id: 'EU_ActivAdvantage_Chicken_Rice_Medium_Breed_Adult_3kg',
    name: 'Eukanuba ActivAdvantage Chicken & Rice Medium Breed Adult (3kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3,
    price: 258,
    category: 'Dry food',
    brand: 'Eukanuba',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'medium',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Complete feed for dogs - Suitable for medium breed adults (11kg to 24.5kg) from 1 to 7 years in age.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - Suitable for medium breed adults (11kg to 24.5kg) from 1 to 7 years in age.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Maintains Ideal Weight - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Healthy Skin & Coat - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Digestive Health - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Maintains Ideal Weight -',
      'Healthy Skin & Coat -',
      'Digestive Health -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Eukanuba',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/EU_ActivAdvantage_Chicken_Rice_Medium_Breed_Adult_9kg.jpg',
    id: 'EU_ActivAdvantage_Chicken_Rice_Medium_Breed_Adult_9kg',
    name: 'Eukanuba ActivAdvantage Chicken & Rice Medium Breed Adult (9kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 9,
    price: 664,
    category: 'Dry food',
    brand: 'Eukanuba',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'medium',
    sterilised: 'No',
    productSize: '5.1-10kg',
    description:
      'Complete feed for dogs - Suitable for medium breed adults (11kg to 24.5kg) from 1 to 7 years in age.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - Suitable for medium breed adults (11kg to 24.5kg) from 1 to 7 years in age.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Maintains Ideal Weight - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Healthy Skin & Coat - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Digestive Health - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Maintains Ideal Weight -',
      'Healthy Skin & Coat -',
      'Digestive Health -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Eukanuba',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/EU_ActivAdvantage_Chicken_Rice_Medium_Breed_Adult_15kg.jpg',
    id: 'EU_ActivAdvantage_Chicken_Rice_Medium_Breed_Adult_15kg',
    name: 'Eukanuba ActivAdvantage Chicken & Rice Medium Breed Adult (15kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 15,
    price: 1005,
    category: 'Dry food',
    brand: 'Eukanuba',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'medium',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'Complete feed for dogs - Suitable for medium breed adults (11kg to 24.5kg) from 1 to 7 years in age.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - Suitable for medium breed adults (11kg to 24.5kg) from 1 to 7 years in age.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Maintains Ideal Weight - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Healthy Skin & Coat - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Digestive Health - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Maintains Ideal Weight -',
      'Healthy Skin & Coat -',
      'Digestive Health -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Eukanuba',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/EU_ActivAdvantage_Chicken_Rice_Medium_Breed_Senior_3kg.jpg',
    id: 'EU_ActivAdvantage_Chicken_Rice_Medium_Breed_Senior_3kg',
    name: 'Eukanuba ActivAdvantage Chicken & Rice Medium Breed Senior (3kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3,
    price: 252,
    category: 'Dry food',
    brand: 'Eukanuba',
    age: 'Senior',
    breed: '',
    needs: 'General',
    size: 'medium',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Complete feed for dogs - Suitable for medium breed seniors (11kg to 24.5kg) over 7 years old.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - Suitable for medium breed seniors (11kg to 24.5kg) over 7 years old.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Healthy Ageing - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Joint Support - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Skin & Coat Support - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Healthy Ageing -',
      'Joint Support -',
      'Skin & Coat Support -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Eukanuba',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Senior',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/EU_ActivAdvantage_Chicken_Rice_Medium_Breed_Senior_15kg.jpg',
    id: 'EU_ActivAdvantage_Chicken_Rice_Medium_Breed_Senior_15kg',
    name: 'Eukanuba ActivAdvantage Chicken & Rice Medium Breed Senior (15kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 15,
    price: 1097,
    category: 'Dry food',
    brand: 'Eukanuba',
    age: 'Senior',
    breed: '',
    needs: 'General',
    size: 'medium',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'Complete feed for dogs - Suitable for medium breed seniors (11kg to 24.5kg) over 7 years old.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - Suitable for medium breed seniors (11kg to 24.5kg) over 7 years old.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Healthy Ageing - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Joint Support - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Skin & Coat Support - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Healthy Ageing -',
      'Joint Support -',
      'Skin & Coat Support -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Eukanuba',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Senior',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/EU_ActivAdvantage_Chicken_Rice_Large_Breed_Puppy_3kg.jpg',
    id: 'EU_ActivAdvantage_Chicken_Rice_Large_Breed_Puppy_3kg',
    name: 'Eukanuba ActivAdvantage Chicken & Rice Large Breed Puppy (3kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3,
    price: 245,
    category: 'Dry food',
    brand: 'Eukanuba',
    age: 'Puppy',
    breed: '',
    needs: 'General',
    size: 'large',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Complete feed for dogs - Suitable for large breed puppies (adult weight 25kg to 45kg) from 1 to 15 months in age. Suitable for giant breed puppies (adult weight greater than 45kg) from 1 to 24 months in age.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - Suitable for large breed puppies (adult weight 25kg to 45kg) from 1 to 15 months in age. Suitable for giant breed puppies (adult weight greater than 45kg) from 1 to 24 months in age.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Immune System Support - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Digestive Health - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Growth Support - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Immune System Support -',
      'Digestive Health -',
      'Growth Support -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Eukanuba',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/EU_ActivAdvantage_Chicken_Rice_Large_Breed_Puppy_9kg.jpg',
    id: 'EU_ActivAdvantage_Chicken_Rice_Large_Breed_Puppy_9kg',
    name: 'Eukanuba ActivAdvantage Chicken & Rice Large Breed Puppy (9kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 9,
    price: 655,
    category: 'Dry food',
    brand: 'Eukanuba',
    age: 'Puppy',
    breed: '',
    needs: 'General',
    size: 'large',
    sterilised: 'No',
    productSize: '5.1-10kg',
    description:
      'Complete feed for dogs - Suitable for large breed puppies (adult weight 25kg to 45kg) from 1 to 15 months in age. Suitable for giant breed puppies (adult weight greater than 45kg) from 1 to 24 months in age.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - Suitable for large breed puppies (adult weight 25kg to 45kg) from 1 to 15 months in age. Suitable for giant breed puppies (adult weight greater than 45kg) from 1 to 24 months in age.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Immune System Support - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Digestive Health - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Growth Support - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Immune System Support -',
      'Digestive Health -',
      'Growth Support -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Eukanuba',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/EU_ActivAdvantage_Chicken_Rice_Large_Breed_Puppy_15kg.jpg',
    id: 'EU_ActivAdvantage_Chicken_Rice_Large_Breed_Puppy_15kg',
    name: 'Eukanuba ActivAdvantage Chicken & Rice Large Breed Puppy (15kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 15,
    price: 1052,
    category: 'Dry food',
    brand: 'Eukanuba',
    age: 'Puppy',
    breed: '',
    needs: 'General',
    size: 'large',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'Complete feed for dogs - Suitable for large breed puppies (adult weight 25kg to 45kg) from 1 to 15 months in age. Suitable for giant breed puppies (adult weight greater than 45kg) from 1 to 24 months in age.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - Suitable for large breed puppies (adult weight 25kg to 45kg) from 1 to 15 months in age. Suitable for giant breed puppies (adult weight greater than 45kg) from 1 to 24 months in age.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Immune System Support - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Digestive Health - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Growth Support - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Immune System Support -',
      'Digestive Health -',
      'Growth Support -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Eukanuba',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/EU_ActivAdvantage_Chicken_Rice_Large_Breed_Adult_3kg.jpg',
    id: 'EU_ActivAdvantage_Chicken_Rice_Large_Breed_Adult_3kg',
    name: 'Eukanuba ActivAdvantage Chicken & Rice Large Breed Adult (3kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3,
    price: 270,
    category: 'Dry food',
    brand: 'Eukanuba',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'large',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Complete feed for dogs - Suitable for large breed adults (25kg to 45kg) from 15 months in age. Suitable for giant breed adults (greater than 45kg) from 2 years in age.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - Suitable for large breed adults (25kg to 45kg) from 15 months in age. Suitable for giant breed adults (greater than 45kg) from 2 years in age.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Maintains Ideal Weight - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Healthy Skin & Coat - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Digestive Health - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Maintains Ideal Weight -',
      'Healthy Skin & Coat -',
      'Digestive Health -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Eukanuba',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/EU_ActivAdvantage_Chicken_Rice_Large_Breed_Adult_9kg.jpg',
    id: 'EU_ActivAdvantage_Chicken_Rice_Large_Breed_Adult_9kg',
    name: 'Eukanuba ActivAdvantage Chicken & Rice Large Breed Adult (9kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 9,
    price: 605,
    category: 'Dry food',
    brand: 'Eukanuba',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'large',
    sterilised: 'No',
    productSize: '5.1-10kg',
    description:
      'Complete feed for dogs - Suitable for large breed adults (25kg to 45kg) from 15 months in age. Suitable for giant breed adults (greater than 45kg) from 2 years in age.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - Suitable for large breed adults (25kg to 45kg) from 15 months in age. Suitable for giant breed adults (greater than 45kg) from 2 years in age.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Maintains Ideal Weight - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Healthy Skin & Coat - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Digestive Health - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Maintains Ideal Weight -',
      'Healthy Skin & Coat -',
      'Digestive Health -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Eukanuba',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/EU_ActivAdvantage_Chicken_Rice_Large_Breed_Adult_15kg.jpg',
    id: 'EU_ActivAdvantage_Chicken_Rice_Large_Breed_Adult_15kg',
    name: 'Eukanuba ActivAdvantage Chicken & Rice Large Breed Adult (15kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 15,
    price: 1007,
    category: 'Dry food',
    brand: 'Eukanuba',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'large',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'Complete feed for dogs - Suitable for large breed adults (25kg to 45kg) from 15 months in age. Suitable for giant breed adults (greater than 45kg) from 2 years in age.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - Suitable for large breed adults (25kg to 45kg) from 15 months in age. Suitable for giant breed adults (greater than 45kg) from 2 years in age.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Maintains Ideal Weight - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Healthy Skin & Coat - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Digestive Health - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Maintains Ideal Weight -',
      'Healthy Skin & Coat -',
      'Digestive Health -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Eukanuba',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/EU_ActivAdvantage_Chicken_Rice_Large_Breed_Senior_15kg.jpg',
    id: 'EU_ActivAdvantage_Chicken_Rice_Large_Breed_Senior_15kg',
    name: 'Eukanuba ActivAdvantage Chicken & Rice Large Breed Senior (15kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 15,
    price: 1031,
    category: 'Dry food',
    brand: 'Eukanuba',
    age: 'Senior',
    breed: '',
    needs: 'General',
    size: 'large',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'Complete feed for dogs - Suitable for large breed seniors (25kg to 45kg) over 6 years old. Suitable for giant breed seniors (greater than 45kg) over 5 years old.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - Suitable for large breed seniors (25kg to 45kg) over 6 years old. Suitable for giant breed seniors (greater than 45kg) over 5 years old.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Healthy Ageing - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Joint Support - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Skin & Coat Support - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Healthy Ageing -',
      'Joint Support -',
      'Skin & Coat Support -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Eukanuba',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Senior',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/EU_ActivAdvantage_Lamb_Rice_Large_Breed_Adult_3kg.jpg',
    id: 'EU_ActivAdvantage_Lamb_Rice_Large_Breed_Adult_3kg',
    name: 'Eukanuba ActivAdvantage Lamb & Rice Large Breed Adult (3kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3,
    price: 294,
    category: 'Dry food',
    brand: 'Eukanuba',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'large',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Complete feed for dogs - Suitable for large breed adults (25kg to 45kg) from 15 months in age. Suitable for giant breed adults (greater than 45kg) from 2 years in age.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - Suitable for large breed adults (25kg to 45kg) from 15 months in age. Suitable for giant breed adults (greater than 45kg) from 2 years in age.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Maintains Ideal Weight - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Healthy Skin & Coat - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Digestive Health - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Maintains Ideal Weight -',
      'Healthy Skin & Coat -',
      'Digestive Health -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Eukanuba',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/EU_ActivAdvantage_Lamb_Rice_Large_Breed_Adult_15kg.jpg',
    id: 'EU_ActivAdvantage_Lamb_Rice_Large_Breed_Adult_15kg',
    name: 'Eukanuba ActivAdvantage Lamb & Rice Large Breed Adult (15kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 15,
    price: 1130,
    category: 'Dry food',
    brand: 'Eukanuba',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'large',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'Complete feed for dogs - Suitable for large breed adults (25kg to 45kg) from 15 months in age. Suitable for giant breed adults (greater than 45kg) from 2 years in age.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - Suitable for large breed adults (25kg to 45kg) from 15 months in age. Suitable for giant breed adults (greater than 45kg) from 2 years in age.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Maintains Ideal Weight - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Healthy Skin & Coat - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Digestive Health - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Maintains Ideal Weight -',
      'Healthy Skin & Coat -',
      'Digestive Health -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Eukanuba',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/EU_Fit_Body_Small_Breed_Adult_1kg.jpg',
    id: 'EU_Fit_Body_Small_Breed_Adult_1kg',
    name: 'Eukanuba Fit Body Small Breed Adult (1kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1,
    price: 109,
    category: 'Dry food',
    brand: 'Eukanuba',
    age: 'Adult',
    breed: '',
    needs: 'Weight care',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Complete feed for dogs - Suitable for small breed adults (less than 11kg) from 1 year onward with a tendancy to gain weight.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - Suitable for small breed adults (less than 11kg) from 1 year onward with a tendancy to gain weight.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Helps Limit Weight Gain - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Maintains Muscle Mass - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Helps Limit Weight Gain -',
      'Maintains Muscle Mass -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Eukanuba',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/EU_Fit_Body_Small_Breed_Adult_7_5kg.jpg',
    id: 'EU_Fit_Body_Small_Breed_Adult_7_5kg',
    name: 'Eukanuba Fit Body Small Breed Adult (7.5kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 7.5,
    price: 625,
    category: 'Dry food',
    brand: 'Eukanuba',
    age: 'Adult',
    breed: '',
    needs: 'Weight care',
    size: 'small',
    sterilised: 'No',
    productSize: '5.1-10kg',
    description:
      'Complete feed for dogs - Suitable for small breed adults (less than 11kg) from 1 year onward with a tendancy to gain weight.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - Suitable for small breed adults (less than 11kg) from 1 year onward with a tendancy to gain weight.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Helps Limit Weight Gain - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Maintains Muscle Mass - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Helps Limit Weight Gain -',
      'Maintains Muscle Mass -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Eukanuba',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/EU_Fit_Body_Large_Breed_Adult_15kg.jpg',
    id: 'EU_Fit_Body_Large_Breed_Adult_15kg',
    name: 'Eukanuba Fit Body Large Breed Adult (15kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 15,
    price: 1209,
    category: 'Dry food',
    brand: 'Eukanuba',
    age: 'Adult',
    breed: '',
    needs: 'Weight care',
    size: 'large',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'Complete feed for dogs - Suitable for large breed adults (25kg to 45kg) from 15 months in age, with a tendancy to gain weight. Suitable for giant breed adults (greater than 45kg) from 2 years in age, with a tendancy to gain weight.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - Suitable for large breed adults (25kg to 45kg) from 15 months in age, with a tendancy to gain weight. Suitable for giant breed adults (greater than 45kg) from 2 years in age, with a tendancy to gain weight.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Helps Limit Weight Gain - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Maintains Muscle Mass - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Helps Limit Weight Gain -',
      'Maintains Muscle Mass -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Eukanuba',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/EU_Premium_Performance_Exercise_26_16_Adult_15kg.jpg',
    id: 'EU_Premium_Performance_Exercise_26_16_Adult_15kg',
    name: 'Eukanuba Premium Performance Exercise 26:16 Adult (15kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 15,
    price: 1188,
    category: 'Dry food',
    brand: 'Eukanuba',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'medium',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'Complete feed for dogs - Designed to support more active, adult pets or service dogs to help them maintain peak performance during regular activities.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - Designed to support more active, adult pets or service dogs to help them maintain peak performance during regular activities.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Maintains Ideal Weight - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Healthy Skin & Coat - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Digestive Health - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Maintains Ideal Weight -',
      'Healthy Skin & Coat -',
      'Digestive Health -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Eukanuba',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
];

export { eukanubaProducts };
